export default __webpack_public_path__ + "static/media/Archpriest's Belt of the Nine Springs.7f46111a.jpg";